import { Projection } from 'mapbox-gl';

export enum MAPBOX_STYLES {
  default = 'default',
}

export const MAPBOX_STYLE_URLS = {
  default: 'mapbox://styles/mapbox/streets-v12',
};

// streets-v12 renders a globe at low zoom; search bounds and viewport fitting assume a flat map.
export const MAPBOX_PROJECTION: Projection = { name: 'mercator' };
